






























import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import SearchInput from "@/components/SearchInput.vue";
import BackButton from "@/components/BackButton.vue";
import PinboardListCard from "@/components/Admin/PinboardListCard.vue";
import PinboardModal from "@/components/Admin/PinboardModal.vue";

import { pinboardService } from "@/services/pinboard.service";
import { PinBoard } from '@/models/PinBoard.model';
import store from "@/store/store";


@Component({
    components : {
        SearchInput,
        BackButton,
        PinboardListCard,
        PinboardModal
    }
})
export default class AdminPinBoard extends Vue{
    filterWeek:boolean = true;
    filterMonth:boolean = false;
    isModalVisible:boolean = false;
    pinboards:PinBoard[] = [];
    pinboardId:number = 0;

    searchQuery:string = "";

    async created(){
        this.load();
    }

    async load(){
        this.pinboards = await pinboardService.getAll(this.$store.getters["app/companyId"]);
        this.$store.dispatch("app/getCompanyPinBoards");
    }

    edit(id:number){
        this.pinboardId = id;
        this.isModalVisible = true;
    }

    async remove(id:number){
        var r = confirm("Sure you want to delete?");
        if (r == true) {
            pinboardService.delete(id).then(() => {
                this.$store.dispatch("app/getCompanyPinBoards");
                this.load();
                this.$notify({
                    group: 'message',
                    title: 'Succe!',
                    text: 'Tavla borttaget',
                    duration: 5000,
                    type: 'success',
                });
            });
        }
    }

    get filteredList(){
        let filterList = this.pinboards;
        if(this.searchQuery != "" && this.searchQuery.length > 1){
            filterList = filterList.filter(c => c.name!.toLowerCase().startsWith(this.searchQuery.toLowerCase()));
        }

        return filterList;
    }

    openModal(){
        this.pinboardId = 0;
        this.isModalVisible = true;
    }

    modalEvent(obj:any,id:any){
        this.isModalVisible = obj == "close" || obj == "saved" ? false : true;
        this.pinboardId = id != undefined ? id : this.pinboardId;
        if(obj="saved")
            this.load();
    }


    
}
